"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var View24Icon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'view-24', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    height: "24",
    width: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "path-1-inside-1_31259_29306",
    fill: "white"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.90928 14.7586C5.08445 17.6238 8.32387 19.4998 12 19.5C15.6761 19.4998 18.9155 17.6238 21.0907 14.7586C22.3027 13.1626 22.303 10.8369 21.092 9.24158C18.9157 6.37657 15.6771 4.5 12.0005 4.5C8.32384 4.5 5.08424 6.37657 2.90798 9.24158C1.69695 10.8369 1.6973 13.1626 2.90928 14.7586Z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 19.5L11.9999 21.5H12.0001L12 19.5ZM2.90928 14.7586L4.50224 13.5492L4.50207 13.549L2.90928 14.7586ZM21.0907 14.7586L19.4979 13.549L19.4977 13.5492L21.0907 14.7586ZM21.092 9.24158L22.685 8.03229L22.6846 8.03182L21.092 9.24158ZM2.90798 9.24158L1.31535 8.03182L1.31499 8.03229L2.90798 9.24158ZM12.0001 17.5C9.041 17.4998 6.35836 15.9942 4.50224 13.5492L1.31631 15.9679C3.81054 19.2534 7.60675 21.4997 11.9999 21.5L12.0001 17.5ZM12.0001 21.5C16.3932 21.4997 20.1894 19.2534 22.6836 15.9679L19.4977 13.5492C17.6416 15.9942 14.959 17.4998 11.9999 17.5L12.0001 21.5ZM22.6835 15.9681C24.4381 13.6576 24.439 10.3429 22.685 8.03229L19.499 10.4509C20.167 11.3309 20.1673 12.6676 19.4979 13.549L22.6835 15.9681ZM22.6846 8.03182C20.1897 4.74728 16.3946 2.5 12.0005 2.5V6.5C14.9597 6.5 17.6418 8.00585 19.4993 10.4513L22.6846 8.03182ZM4.50062 10.4513C6.35807 8.00602 9.04109 6.5 12.0005 6.5V2.5C7.60658 2.5 3.8104 4.74711 1.31535 8.03182L4.50062 10.4513ZM4.50207 13.549C3.83271 12.6676 3.83295 11.3309 4.50098 10.4509L1.31499 8.03229C-0.439055 10.3429 -0.438103 13.6576 1.31648 15.9681L4.50207 13.549Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_31259_29306)"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    fill: "currentColor",
    r: "3"
  }));
});
var _default = View24Icon;
exports.default = _default;